import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DataGrid, Stack, Typography } from '@emburse/embark-core';
import { $t, useTranslation } from '../../hooks/useTranslation';
import { buildParametersColumn, ruleColumn, statusColumn } from './DataGrid/Columns';
import localeText from './DataGrid/LocaleText';
function CorpAuditConfigInvalidExpenseTypes({ data, onEdit }) {
    useTranslation();
    const hasData = data && data.length > 0;
    return (_jsxs(Stack, { alignItems: "flex-start", sx: { width: '100%' }, children: [_jsx(Typography, { variant: "subtitle1", children: $t('Invalid Expense Types') }), _jsx(DataGrid, { rows: hasData ? data : [], columns: [statusColumn, ruleColumn, buildParametersColumn($t('Keyword'), onEdit)], localeText: localeText, sx: { width: '100%' }, rowCount: data.length, paginationMode: "server", sortModel: [], autoHeight: true, hideFooter: true })] }));
}
export default CorpAuditConfigInvalidExpenseTypes;
